// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clock__mb0VY {
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/components/clock/clock.module.scss"],"names":[],"mappings":"AAAA;EACE,4CAAA;AACF","sourcesContent":[".clock {\n  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clock": `clock__mb0VY`
};
export default ___CSS_LOADER_EXPORT___;
